module.exports = __webpack_public_path__ + "media/images/poland-flag-round-a791a8a59d0f1e734bf52b6e6abf1814.png";